import { render, staticRenderFns } from "./cms-bar-component.vue?vue&type=template&id=647e3578&"
import script from "./cms-bar-component.vue?vue&type=script&lang=js&"
export * from "./cms-bar-component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports